export interface ILanguageSpeak {
    isExist?: boolean;
    optional?: string;
    speakerGenderRestriction?: string;
}

export interface ILanguage {
    full: string;
    speak?: ILanguageSpeak;
}

export class Languages {
    [key: string]: ILanguage
}



// WEBPACK FOOTER //
// ./src/app/shared/location/countries-data/models/languages.model.ts